// extracted by mini-css-extract-plugin
export default {"changesWrap":"changesForm_changesWrap__MMJmB"};